var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSettings = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 4,
  stroke: "currentColor"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  d: "M9.796 2.678c.998-1.665 3.41-1.665 4.408 0a2.57 2.57 0 0 0 2.829 1.172c1.883-.472 3.589 1.234 3.117 3.117a2.57 2.57 0 0 0 1.172 2.829c1.665.998 1.665 3.41 0 4.408a2.57 2.57 0 0 0-1.172 2.829c.472 1.883-1.234 3.589-3.117 3.117a2.57 2.57 0 0 0-2.829 1.172c-.998 1.665-3.41 1.665-4.408 0a2.57 2.57 0 0 0-2.829-1.172c-1.883.472-3.589-1.234-3.117-3.117a2.57 2.57 0 0 0-1.172-2.829c-1.665-.998-1.665-3.41 0-4.408A2.57 2.57 0 0 0 3.85 6.967C3.378 5.084 5.084 3.378 6.967 3.85a2.57 2.57 0 0 0 2.829-1.172Z"
})));
export default SvgSettings;